import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import reducer from './reducers'

// const debounceNotify = _.debounce((notify) => notify())
const defaultMiddleWare: any[] = []
if (process.env.NODE_ENV !== 'production') {
  defaultMiddleWare.push(logger)
}

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(defaultMiddleWare),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: {},
  // enhancers: [batchedSubscribe(debounceNotify)],
})

export default store
